module.exports = __webpack_public_path__ + "static/media/import.1d5c5bd7.png";